import { render, staticRenderFns } from "./CreditsPicker.vue?vue&type=template&id=be00c520"
import script from "./CreditsPicker.vue?vue&type=script&lang=js"
export * from "./CreditsPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports